export default "__VITE_ASSET__lncQhYyd__"